import React from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  Avatar,
  Stack,
  alpha,
  useTheme,
  Divider,
  IconButton,
  Tooltip,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Agriculture,
  Logout,
  Person,
  Terrain,
  Construction,
  FolderSpecial,
  Storage,
} from "@mui/icons-material";

export default function Navbar({ user, setUser }) {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();

  const handleLogout = () => {
    localStorage.removeItem("fieldUser");
    localStorage.removeItem("fieldToken"); // YENİ EKLENEN: Token'ı temizle
    setUser(null);
    navigate("/");
  };

  // --- İŞE ÖZEL SİMGELER ---
  const navItems =
    user?.role === "admin"
      ? [
          {
            label: "Profil Arşivi",
            path: "/admin/profiles",
            icon: <FolderSpecial />,
          },
          { label: "Sonda Arşivi", path: "/admin/sondas", icon: <Storage /> },
        ]
      : [
          {
            label: "Profil Girişi",
            path: "/field",
            icon: <Terrain />,
            color: "#795548",
          },
          {
            label: "Sonda Girişi",
            path: "/field/sonda",
            icon: <Construction />,
          },
        ];

  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        bgcolor: alpha("#fff", 0.8),
        backdropFilter: "blur(12px)",
        borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
        top: 0,
        zIndex: theme.zIndex.drawer + 1,
      }}
    >
      <Toolbar sx={{ justifyContent: "space-between" }}>
        {/* LOGO */}
        <Box
          onClick={() => navigate("/")}
          sx={{
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            minWidth: { xs: "auto", sm: 120 },
            "&:hover": {
              "& .logo-text": {
                color: "primary.dark",
                transform: "scale(1.02)",
              },
            },
          }}
        >
          <Typography
            className="logo-text"
            variant="h5"
            sx={{
              fontWeight: 900,
              color: "primary.main",
              letterSpacing: "1px",
              textTransform: "uppercase",
              transition: "all 0.2s ease-in-out",
              fontFamily: "'Montserrat', sans-serif",
              position: "relative",
              display: "flex",
              alignItems: "center",
              "&::after": {
                content: '""',
                width: "4px",
                height: "4px",
                bgcolor: "secondary.main",
                borderRadius: "50%",
                ml: 0.5,
                mt: 1,
              },
            }}
          >
            HTC
          </Typography>
        </Box>

        {/* ORTA NAVİGASYON (SİMGELER BURADA) */}
        {user && (
          <Stack
            direction="row"
            spacing={{ xs: 1, sm: 2 }}
            sx={{
              flexGrow: 1,
              justifyContent: { xs: "center", md: "flex-start" },
              ml: { md: 4 },
            }}
          >
            {navItems.map((item) => {
              const isActive = location.pathname === item.path;
              const activeColor = item.color || theme.palette.primary.main;

              return (
                <React.Fragment key={item.path}>
                  {/* Masaüstü Buton */}
                  <Button
                    startIcon={React.cloneElement(item.icon, {
                      sx: { color: isActive ? activeColor : "inherit" },
                    })}
                    onClick={() => navigate(item.path)}
                    sx={{
                      borderRadius: "12px",
                      textTransform: "none",
                      fontWeight: isActive ? 800 : 500,
                      px: 2,
                      color: isActive ? activeColor : "text.secondary",
                      bgcolor: isActive
                        ? alpha(activeColor, 0.1)
                        : "transparent",
                      display: { xs: "none", md: "flex" },
                      "&:hover": {
                        bgcolor: alpha(activeColor, 0.05),
                      },
                    }}
                  >
                    {item.label}
                  </Button>

                  {/* Mobil Buton */}
                  <Tooltip title={item.label}>
                    <Box
                      sx={{
                        display: { xs: "flex", md: "none" },
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                    >
                      <IconButton
                        onClick={() => navigate(item.path)}
                        sx={{
                          color: isActive ? "#fff" : "text.secondary",
                          bgcolor: isActive ? activeColor : "transparent",
                          borderRadius: "12px",
                          "&:hover": {
                            bgcolor: isActive
                              ? activeColor
                              : alpha(activeColor, 0.1),
                          },
                        }}
                      >
                        {item.icon}
                      </IconButton>
                      {isActive && (
                        <Box
                          sx={{
                            width: 4,
                            height: 4,
                            bgcolor: activeColor,
                            borderRadius: "50%",
                            mt: 0.5,
                          }}
                        />
                      )}
                    </Box>
                  </Tooltip>
                </React.Fragment>
              );
            })}
          </Stack>
        )}

        {/* SAĞ TARAF: AVATAR VE ÇIKIŞ */}
        {user ? (
          <Stack direction="row" alignItems="center" spacing={1.5}>
            <Avatar
              sx={{
                bgcolor: "secondary.main",
                width: 34,
                height: 34,
                fontSize: "0.85rem",
                fontWeight: "bold",
                boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
              }}
            >
              {/* full_name bos gelirse tum panel bos ekrana dusuyordu;
                  kullanici adina, o da yoksa "?" isaretine duseriz. */}
              {(user.full_name || user.username || "?").charAt(0)}
            </Avatar>

            <IconButton
              onClick={handleLogout}
              size="small"
              sx={{
                color: "error.main",
                bgcolor: alpha(theme.palette.error.main, 0.05),
              }}
            >
              <Logout sx={{ fontSize: 20 }} />
            </IconButton>
          </Stack>
        ) : null}
      </Toolbar>
    </AppBar>
  );
}
